// DigiTrans brand assets & colors — one source of truth for the whole app.

export const BRAND = {
  // Served from /public — always same-origin, so it works in preview and on any
  // custom production domain without CORS/referrer restrictions.
  logoUrl: "/digitrans-logo.png",
  colors: {
    blue: "#387EE6",
    blueDeep: "#2563EB",
    green: "#22C55E",
    greenDeep: "#16A34A",
    orange: "#F97316",
    ink: "#0F172A", // dark slate — replaces pure black for text/UI
  },
};

/**
 * Small brand mark used inside page headers.
 * Shows the DigiTrans logo with an accent orange triangle.
 */
export function BrandMark({ subtitle, className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative shrink-0">
        <img
          src={BRAND.logoUrl}
          alt="DigiTrans Technology"
          className="h-9 w-auto object-contain select-none"
          draggable={false}
        />
        <span
          aria-hidden
          className="absolute -top-1 -right-1 block"
          style={{
            width: 0,
            height: 0,
            borderLeft: "5px solid transparent",
            borderRight: "5px solid transparent",
            borderBottom: `8px solid ${BRAND.colors.orange}`,
            transform: "rotate(15deg)",
            filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.15))",
          }}
        />
      </div>
      {subtitle ? (
        <div className="flex flex-col leading-tight min-w-0">
          <span
            className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 truncate"
            style={{ fontFamily: "IBM Plex Mono, monospace" }}
          >
            {subtitle}
          </span>
        </div>
      ) : null}
    </div>
  );
}

/**
 * Big brand block for the Login page. Blue → green gradient panel with an
 * orange triangle accent behind the logo.
 */
export function BrandHero() {
  return (
    <div className="relative flex items-center gap-4">
      <div className="relative">
        {/* Orange triangle accent behind the logo */}
        <div
          aria-hidden
          className="absolute -top-6 -left-6 z-0"
          style={{
            width: 0,
            height: 0,
            borderLeft: "22px solid transparent",
            borderRight: "22px solid transparent",
            borderBottom: `36px solid ${BRAND.colors.orange}`,
            transform: "rotate(-18deg)",
            filter: "drop-shadow(0 4px 12px rgba(249,115,22,0.5))",
          }}
        />
        <div className="relative z-10 bg-white rounded-xl p-4 shadow-xl">
          <img
            src={BRAND.logoUrl}
            alt="DigiTrans Technology"
            className="h-14 w-auto object-contain select-none"
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
}
